// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button__button___315aS{border-radius:8px}.button__button___315aS:disabled{opacity:.7;cursor:default}.button__block___1s8qe{width:100%}.button__primary___1YtOM{background-color:var(--primary-button-background-color);color:var(--primary-button-font-color)}.button__primary___1YtOM:hover:enabled{background-color:var(--primary-button-background-hover-color)}.button__secondary___2KuPm{background-color:#717070;color:#fff}.button__secondary___2KuPm:hover:enabled{background-color:#4d4d51}.button__danger___3a4uo{background-color:#fff;border:1px solid red;color:red}.button__danger___3a4uo:hover:enabled{background-color:red;color:#fff}.button__link___EHpw7{padding:0;background-color:#fff;border:0;color:var(--primary-button-background-color)}.button__link___EHpw7:hover:enabled{text-decoration:underline}.button__outlinePrimary___3Y_TJ{border:1px solid var(--primary-button-background-color);color:var(--primary-button-background-color);background-color:#fff}.button__outlinePrimary___3Y_TJ:hover:enabled{background-color:var(--primary-button-background-color);color:var(--primary-button-font-color)}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "button__primary___1YtOM",
	"secondary": "button__secondary___2KuPm",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"button": "button__button___315aS",
	"block": "button__block___1s8qe",
	"danger": "button__danger___3a4uo",
	"link": "button__link___EHpw7",
	"outlinePrimary": "button__outlinePrimary___3Y_TJ"
};
module.exports = exports;
